import React, { useEffect } from "react"
import Layout from "../components/layout"
import Content from "../components/content"
import LoginPage from "../components/pages/login"
import { useAuth } from "../services/auth"
import { useIntl } from "gatsby-plugin-intl"
import { useAppContext } from "../context"
import { timeout } from "../utils/useTimeout";

const getRegion = () => {
    return process.env.APP_REGION ? process.env.APP_REGION.toLocaleLowerCase() : 'global';
}  

const ProtectedContent = () => {
    const { locale } = useIntl()
    const { isAuthenticated, assets } = useAuth()
    const { autoStart, autoStartPage, setPages, setCurrent, setAutoStartPage, setAudio, setStarted, setPageTransition } = useAppContext();
    const region = getRegion();

    useEffect(() => {
        const execFetch = async () => {
            if (autoStart && isAuthenticated) setPageTransition(true);
            const pages = await assets(locale, region);
            //console.warn("pages", { pages })
            setPages(pages);
            if (autoStartPage && autoStartPage.trim().length) {
                setCurrent(parseInt(autoStartPage));
                await timeout(100);
                setAutoStartPage(null, -1);
                setAudio(true);
                setStarted(true);
            } else {
                setCurrent(0);
                if (autoStart) {
                    await timeout(100);
                    setAutoStartPage(null, -1);
                    setAudio(true);
                    setStarted(true);                  
                }                
            }
            setPageTransition(false);
        }
        isAuthenticated && execFetch()
    }, [locale, isAuthenticated])

    return isAuthenticated ? <Content /> : <LoginPage />
}

export default () => (
    <Layout>
        <ProtectedContent />
    </Layout>
)